//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { IInstagramSourceAndCount } from '@instagram-account/models/IInstagramAutocompleteResponses';
import DateString from '@models/DateString';
import InstagramHashtag from '@models/InstagramHashtag';
import { FilterMatchState } from '@models/FilterMatchState';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { UniversalSearchSortKey } from '@models/UniversalSearchSortKey';

export interface IInstagramHashtagHistoricalMetricsRequest {
  sourceId: InstagramHashtag;
  startTime: DateString;
  endTime: DateString;
}

export interface IInstagramDailyHistoricalMetrics {
  date: number;
  documentCount: number;
  likes: IInstagramDailyHistoricalMetricsNumbers;
  comments: IInstagramDailyHistoricalMetricsNumbers;
  followers: IInstagramDailyHistoricalMetricsNumbers;
}

export interface IInstagramDailyHistoricalMetricsNumbers {
  average: number;
  sum: number;
}

export interface IInstagramHashtagTopContentRequest {
  sourceId: InstagramHashtag;
  startTime: DateString;
  endTime: DateString;
  limit?: number;
  offset?: number;
  sort: InstagramHashtagTopContentSortKey;
}

export enum InstagramHashtagTopContentSortKey {
  COMMENTS = 'Comments',
  LIKES = 'Likes',
  RECENT = 'Recent',
}

interface IInstagramHashtagRecentContentRequestBase {
  hashtag: InstagramHashtag;
  matchState: FilterMatchState;
  startTime: DateString;
  endTime: DateString;
}

export interface IInstagramHashtagRecentContentRequest
  extends IInstagramHashtagRecentContentRequestBase {
  offset?: number;
  limit?: number;
  sortKey: UniversalSearchSortKey;
}

export interface IInstagramHashtagMediaResponse {
  data: IInstagramHashtagMediaData;
}

export interface IInstagramHashtagMediaData {
  media: IMlsMediaItem[];
  offset: number;
  totalCount: number;
}

export interface IInstagramHashtagTrackedHashtagsResponse {
  data: InstagramHashtag[];
}

export interface IInstagramHashtagTrackedDateResponse {
  data: number;
}

export interface IInstagramHashtagAutocompleteRequest
  extends IInstagramHashtagRecentContentRequestBase {
  searchTerm: string;
}

export interface IInstagramHashtagRelatedHashtagsRequest
  extends IInstagramHashtagRecentContentRequestBase {
  limit?: number;
}

export interface IInstagramHashtagRelatedHashtagsResponse {
  data: IInstagramSourceAndCount[];
}
